// extracted by mini-css-extract-plugin
export default {"floatingButton":"FloatButton_floatingButton__jAopI","visible":"FloatButton_visible__ZgIi0","static":"FloatButton_static__UvscF","buttonText":"FloatButton_buttonText__51DAn"};